module.exports = __webpack_public_path__ + "img/13.77354c1c.png";